<template>
  <div>

  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <div>
      <label class="block text-sm font-bold mb-2 mt-4" for="name">
        Name <span class="text-red-500">*</span>
      </label>

      <ValidationProvider
        rules="required"
        name="name"
        v-slot="{ errors }"
      >
        <input
          name="name"
          type="text"
          id="name"
          class="form-control"
          autocomplete="off"
          v-model="account.name"
        >
        <span class="text-sm text-red-500">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <div class="mt-4">
      <label class="block text-sm font-bold mb-2 mt-4" for="code">
        Code <span class="text-red-500">*</span>
      </label>

      <ValidationProvider
        rules="required"
        name="code"
        v-slot="{ errors }"
      >
        <input
          name="code"
          type="text"
          id="code"
          class="form-control"
          autocomplete="off"
          v-model="account.code"
        >
        <span class="text-sm text-red-500">{{ errors[0] }}</span>
      </ValidationProvider>

    </div>
  </ValidationObserver>


    <div class="flex justify-end">
      <button
        type="button"
        class="btn btn-red px-4 py-2 mt-4"
        @click="reset"
      >
        <i class="fa-xs fas fa-undo"></i>
        <span class="ml-1">RESET</span>
      </button>
      <button type="button" class="btn btn-green px-4 py-2 mt-4 ml-2" @click="save">
        <i class="fas fa-check"></i>
        <span class="ml-2">{{ mode === 'edit' ? 'Update' : 'Save' }}</span>
      </button>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'supplier-account-edit',
  props: {
    supplierID: {},
    accountID: {},
    createAlert: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mode: null,
      editID: null,
      account: this.emptyAccount(),
    }
  },
  mounted() {
    this.setMode()
  },
  watch: {
    supplierID() {
      this.setMode()
    },
    accountID() {
      this.setMode()
    }
  },
  methods: {
    setMode() {
      const name = this.$route.name.split('.')
      if (name[0] === 'supplierAccounts' && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.accountID) {
        this.editID = this.accountID
        this.mode = 'edit'
      } else if (this.$route.params.accountID) {
        this.editID = this.$route.params.accountID
      }

      if (this.mode === 'create') {
        this.account = this.emptyAccount()
      } else {
        if (!this.supplierID) {
          this.$swal.fire('Need supplier ID!', 'Please pass supplierID prop', 'warning')
          this.$route.push('/')
        }
        // get account
        this.get()
      }
    },
    emptyAccount() {
      return {
        supplier_id: '',
        name: '',
        code: '',
      }
    },
    get() {
      return new Promise((resolve, reject) => {
        axios.get('supplier-accounts/' + this.editID)
          .then((response) => {
            const account = response.data
            this.account = Object.assign({}, account)
            resolve(account)
          })
          .catch((error) => reject(error))
      })
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            if (this.mode === 'create') {
              this.account = this.emptyAccount()
            } else {
              this.get()
            }
          }
        })
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      // create / update
      this.account.supplier_id = this.supplierID
      if (this.mode === 'create') {
        axios.post('supplier-accounts', this.account)
          .then((response) => {
            const newAccount = response.data
            this.$emit('created', newAccount)

            if (this.createAlert) {
              this.$swal.fire({
                title: 'Done',
                text: 'Supplier account created successfully!',
                type: 'success',
                confirmButtonText: 'Show me',
                showCancelButton: true,
                cancelButtonText: 'Create more',
              })
                .then((result) => {
                  if (result.value) {
                    this.$router.push('/supplier/details/' + newAccount.supplier_id)
                  } else {
                    this.account = this.emptyAccount()
                  }
                })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.mode === 'edit') {
        axios.put('supplier-accounts/' + this.editID, this.account)
          .then(() => {
            this.$swal.fire({
              title: 'Done',
              text: 'Supplier account updated successfully!',
              type: 'success',
            })
            this.get()
            this.$emit('updated', this.account)
          })
          .catch((error) => {
            console.log(error)
          })
      }

    },
  }

}
</script>
